/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TCCompany } from '../models/TCCompany';
import type { TCCompanyUpdateBody } from '../models/TCCompanyUpdateBody';
import type { TCNewTenant } from '../models/TCNewTenant';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompaniesService {
    /**
     * @returns TCCompany Ok
     * @throws ApiError
     */
    public static listCompanies(): CancelablePromise<Array<TCCompany>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            },
        });
    }
    /**
     * @returns TCCompany Ok
     * @throws ApiError
     */
    public static getCurrentCompany(): CancelablePromise<TCCompany> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/current',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            },
        });
    }
    /**
     * @param tenantId
     * @returns TCCompany Ok
     * @throws ApiError
     */
    public static getCompanyByTenant(
        tenantId: string,
    ): CancelablePromise<TCCompany> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{tenantId}',
            path: {
                'tenantId': tenantId,
            },
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Company not found.`,
                500: `Internal Server Error.`,
            },
        });
    }
    /**
     * @param tenantId
     * @param requestBody
     * @returns TCCompany Ok
     * @throws ApiError
     */
    public static updateCompany(
        tenantId: string,
        requestBody: TCCompanyUpdateBody,
    ): CancelablePromise<TCCompany> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/companies/{tenantId}',
            path: {
                'tenantId': tenantId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                403: `Forbidden.`,
                404: `Company not found.`,
                500: `Internal Server Error.`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static createTenant(
        requestBody: TCNewTenant,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
            },
        });
    }
}
